import axios, {AxiosResponse} from 'axios';
import { log } from 'util';
// import { EditTea } from '../Models/ViewModels';
import { AuditTrialVM, EmployeeTeamVM,EmployeeRecordsVM, KRAVM } from '../Models/ViewModels';
import { GetUserLoginID } from './UserSessionManager';

const loginId=GetUserLoginID();

const api_url = process.env.REACT_APP_STEM_API_BASE_URL + "/api"

const api_url_local = process.env.REACT_APP_STEM_LOCALAPI

const api_url_EmployeeData=process.env.REACT_APP_STEM_API_BASE_URL

export const GetEmployeeIdInfo = (loginId:any) =>{
 return axios.get(api_url+'/Teams/GetTeamDetails?id='+loginId)
}
const headers = { 
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  } 
   export const EditTeamDetails = (editEmployeeList:EmployeeTeamVM) =>
   {
      const payload = { "EGID" :  editEmployeeList.mapping_id,"EmployeeOfficeBadgeId":editEmployeeList.EmployeeID,
      "TeamName":editEmployeeList.TeamName,"SubTeamName":editEmployeeList.SubTeamName,
      "Process":editEmployeeList.ProcessName,"AllocationPercent":editEmployeeList.AllocationPercent,
      "BufferPercent":editEmployeeList.BufferPercent
   }
   
     return axios.post(api_url+'/Teams/EditTeam',payload,{headers}).then((res)=>{ 
     })
   }
 export const AddEmployeeTeam = (newEmployee:any) =>{
     return axios.post(api_url+'/Teams/AddTeam', {"EmployeeOfficeBadgeId":newEmployee.EmployeeOfficeBadgeId,"TeamName":newEmployee.TeamName,
   "SubTeamName":newEmployee.SubTeamName,"Process":newEmployee.ProcessName,"AllocationPercent":newEmployee.AllocationPercent,
    "BufferPercent":newEmployee.BufferPercent },{headers})
 }

export const DeleteEmployeeTeam=(Mapping_Id:number)=>{
  
  return axios.post(api_url+'/Teams/DeleteTeam?EGID='+ Mapping_Id)
}

export const GetEmployeeTeam = (loginId:any) => axios.get<EmployeeTeamVM[]>(api_url+'/Teams/GetTeam?userid='+loginId)
export const GetEmployeeTeam2 = (loginId:any) => axios.get<KRAVM[]>(api_url+'/Teams/GetTeam?userid='+loginId)
export const GetQMTeam = (loginId:any) => axios.get<EmployeeTeamVM[]>(api_url+'/Teams/GetQMTeam?userid='+loginId)

export const GetTeamDetails = (loginid:any) =>{ 
return axios.get<EmployeeTeamVM[]>(api_url + '/Teams/GetTeamReport?id='+loginid)
}
export const GetManagerDetails = (loginid:any) =>{
  
  return axios.get<EmployeeTeamVM[]>(api_url + '/Teams/ManagerProcessBuffer?id='+loginid)
  }
  export const GetLocationDetails = (loginid:any) =>{
    return axios.get<EmployeeTeamVM[]>(api_url + '/Teams/LocationProcessBuffer?userid='+loginid)
    }
export const GetAuditDetails=(id:any)=>axios.get<AuditTrialVM[]>(api_url+'/AppLog/GetAuditTrial?userid='+id);

export const GetEmployeeCardStats=(loginid:any)=>axios.get(api_url+'/Employee/GetEmployeeCardList?userid='+loginid);

export const GetEmployeeDataStats=(loginid:any)=>axios.get(api_url+'/Employee/GetEmployeeList?userid='+loginid);
export const GetResignedEmployeeList=(loginid:any)=>axios.get(api_url+'/Employee/GetResignedEmployeeList?userid='+loginid);

export const GetEmployeeRecords = (id:any) => axios.get(api_url+'/EmployeeDetails/GetEmployeeDetailsByEmpID?id='+id)
export const GetLastUploaded = () => axios.get(api_url+'/Employee/GetLastUploaded')
export const GetTeamInfo = (id:any) => axios.get(api_url+'/Teams/GetMyTeamDetails?userid='+id)

export const GetEmployeeKRA = (id:any) => axios.get(api_url+'/EmployeeDetails/GetEmployeeKRA?empID='+id )
export const GetAttritionReport = () => axios.get(api_url+'/AppLog/GetEttritionReport')

  export const EditEmployeeDetails=(editDetails:EmployeeRecordsVM)=>{
    const payload1 = {"XliteExtensionNumber": editDetails.XliteExtensionNumber,"RCMTenurity":editDetails.RCMTenurity,
    "WorkStationNumber":editDetails.WorkStationNumber,"Ramp_up_state":editDetails.Ramp_up_state,"ProductionRole":editDetails.ProductionRole,"EmployeeOfficeBadgeId":editDetails.EmployeeOfficeBadgeId}
    return axios.post(api_url+'/EmployeeDetails/EditEmployeeInfo',payload1,{headers}).then((res)=>{
    })
  }

export const GetTeamMembersDetails=(TeamName:string,loginid:string)=>{
  return axios.get(api_url+'/Teams/GetTeamMembersDetails?teamName='+TeamName+'&userid='+loginid)
}
export const GetProcessMembersDetails=(ProcessName:string,teamName:string,loginid:string)=>{
  return axios.get(api_url+'/Teams/GetProcessMembersDetails?processName='+ProcessName+'&teamName='+teamName+'&userid='+loginid)
} 
export const GetLocationMembersDetails=(location:string,loginid:string)=>{
  return axios.get(api_url+'/Teams/GetLocationMembersDetails?id='+loginid+'&location='+location)
} 

export const GetManagerMembersDetails=(loginid:string,managerid:string)=>{
  return axios.get(api_url+'/Teams/GetManagerMemberDetail?userid='+loginid+'&managerid='+managerid)
}
export const GetAttritionReportGraph=(year:string)=>{
  let yr=year.toString().substring(0,4);
  return axios.get(api_url+'/AppLog/GetEttritionReportGraph?year='+yr)}